module.exports = {
  'Products for you': 'Productos para ti',
  'HSBC Total Control App': 'App HSBC Control Total',
  'Keep control of your Debit and Credit Cards where and when you need it, download it here.': 'Mantén el control de tus Tarjetas de Débito y Crédito donde y cuando lo necesitas, descárgala aquí.',
  'No offers available at this time': 'Sin ofertas disponibles en este momento',
  "If you don't have it yet, open it at any branch.": 'Si aún no tienes, ábrelo en cualquier sucursal.',
  'If you already have it, select the option ': 'Si ya lo tienes, selecciona la opción ',
  '"transfer and pay"': '"transferir y pagar"',
  '1.  Source account: your HSBC account': '1.  Cuenta origen: tu cuenta de HSBC',
  '2.  Destination account: ': '2.  Cuenta destino: ',
  'HSBC Flexible Savings': 'Ahorro Flexible HSBC',
};
